module.exports = __webpack_public_path__ + "static/img/banner_mobile6.70d56ec9.jpg";